import { useMemo } from "react";

import { format } from "date-fns";

import banner from "@/../../hypetrain/static/img/exec/home-banner.svg";
import { getUser } from "@/components/session/JwtTokenManager";

export function HomeHeader() {
  const user = getUser();
  const currentDate = useMemo(() => format(new Date(), "iiii, MMMM dd"), []);
  return (
    <div
      className="flex min-h-55 w-full flex-col items-center justify-center bg-cover bg-center p-6 pt-6 pb-20 text-center"
      style={{ backgroundImage: `url(${banner})` }}
    >
      <p className="text-xs font-normal text-white opacity-80">{currentDate}</p>
      <p className="text-4xl font-medium text-white">
        Welcome back, {user?.name}
      </p>
    </div>
  );
}
